/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from "axios"

window.axios = axios

window.axios.defaults.headers.common = {
  "X-CSRF-TOKEN": window.FinancialCents.csrfToken,
  "X-Requested-With": "XMLHttpRequest",
  Accept: "application/json",
}

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || null

    if (timezone) {
      config.headers["TimeZone"] = timezone
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)

/**
 * Make sure the user is notified when they are logged out.
 *
 * @type {boolean}
 */
// window.loggedOut = false
// window.axios.interceptors.response.use((response) => {
//   return response
// }, (error) => {
//   console.error(error.response ? error.response.status : error)
//   if (!window.loggedOut && error.response && error.response.status === 401) {
//     window.loggedOut = true
//     alert('You have been signed out. Refresh the page to sign in.')
//     window.location.reload()
//   }
//   return Promise.reject(error)
// })

// Set CSRF Tokens every 25 minutes
setInterval(
  () => {
    axios
      .get("/api/contract/renew")
      .then((response) => {
        const _token = response.data.data._token

        window.FinancialCents.csrfToken = _token

        window.axios.defaults.headers.common = {
          "X-CSRF-TOKEN": _token,
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        }
      })
      .catch((error) => {
        // ignore errors
        console.error(error)
      })
  },
  1000 * 60 * 25,
)

window.handleError = (response, router) => {
  if (navigator && !navigator.onLine) {
    alert("Network error. Please make sure you are connected to the internet")
    return
  }

  if (!response) {
    router.push("/500")
    return
  }

  if (response.status === 200) {
    return
  }

  if (response.status === 422) {
    return
  }

  if (response.status === 500) {
    router.push("/500")
    return
  }

  if (response.status === 404) {
    router.push("/404")
  }
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo"

import Pusher from "pusher-js"

window.Pusher = Pusher

window.Echo = new Echo({
  broadcaster: "pusher",
  key: window.keys.pusher,
  cluster: "us2",
  forceTLS: window.FinancialCents.env === "production",
})
